import { render, staticRenderFns } from "./PrizePoolSection.vue?vue&type=template&id=3c5e2fb1&scoped=true"
import script from "./PrizePoolSection.vue?vue&type=script&lang=js"
export * from "./PrizePoolSection.vue?vue&type=script&lang=js"
import style0 from "./PrizePoolSection.vue?vue&type=style&index=0&id=3c5e2fb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5e2fb1",
  null
  
)

export default component.exports